import { render, staticRenderFns } from "./UcWorksheetEditorFieldset.yaml?vue&type=template&id=1de54bf0&component"
import script from "./UcWorksheetEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports